<template>
  <div class="bmdiv pfixed tcenter" v-show="isSignUpZz">
    <vue-signature v-bind:is-show-sign.sync="isShowSign" @set-sign="setElectronicSignatureFile"></vue-signature>
    <form class="dinline-block bgw prelative vcenter" method="post">
      <div class="stt tcenter fs18 tc6 pt30 pb30">
        请填写报名信息
      </div>
      <a href="javascript:void(0);" class="close pabsolute br50 hbig twhite" @click="hiddenSign">X</a>
      <div class="mdiv">
        <input type="hidden" name="project_id">
        <input type="text" class="form-control dblock wd100 mb20 trans" id="name" name="name" placeholder="请输入您的姓名" v-model="signName">
        <input type="text" class="form-control dblock wd100 mb20 trans" id="mobile" name="mobile" placeholder="请输入手机号码" v-model="signPhone">
        <input type="text" class="form-control dblock wd100 mb20 trans" id="cid" name="cid" placeholder="请输入身份证号" v-model="cid">
        <input type="text" class="form-control dblock wd100 mb20 trans" id="company" name="cid" placeholder="所在单位" v-model="company">
          <select class="form-control dblock wd100 mb20 trans" id="political_outlook" name="political_outlook" v-model="political_outlook">
          <option value="">请选择政治面貌</option>
          <option v-for="(item,index) in e_list.politic_status" :value="index">{{item}}</option>
        </select>
        <select class="form-control dblock wd100 mb20 trans" id="edu_level" name="edu_level" v-model="edu_level">
          <option value="">请选择文化程度</option>
          <option v-for="(item,index) in e_list.edu_level" :value="index">{{item}}</option>
        </select>
        <div class="tleft fs0">
          <input type="text" class="tcode form-control dinline-block fs14 vtop" id="veri_code" name="veri_code" placeholder="请输入验证码" v-model="signCode">
          <img id="imgCode" class="code dinline-block vtop" title="看不清，换一张" height="35" :src="imgSrc" @click="initImg">
        </div>
        <div class="tleft fs0 signature" @click="isShowSign=true">
          <span>电子签名:</span>
          <input type="checkbox" class="content-select" checked="checked" v-if="electronicSignatureFile" />
          <input type="checkbox" class="content-select" v-else/>
        </div>
        
      </div>
      <a class="zbtn clearn wd100 mt40 mb40 fs18 zbtn-gblue2" @click="subSigUp">提交</a>
    </form>
  </div>
</template>

<script>
import vueSignature from '../../item/vueSignature'
export default {
  name: 'singUpZz',

  components: {
    vueSignature
  },

  props: [
    'projectId',
    'classId',
    'isSignUpZz'
  ],

  data () {
    return {
      'imgSrc': '',
      'signName': '',
      'signPhone': '',
      'signCode': '',
      'cid': '',
      'company': '',
      'isShowSign': false,
      'electronicSignatureFile': '',
      'e_list': [],
      'edu_level': '',
      'political_outlook': ''
    }
  },

  created () {
    this.getdata()
  },

  mounted () {
    this.initImg()
  },

  methods: {
    // showSign:function () {
    //   this.$emit('show-sign-up');
    // },
    setElectronicSignatureFile: function (e, f) {
      this.electronicSignatureFile = e
    },
    hiddenSign: function () {
      console.log('新子组件内的打印，点击关闭')
      this.$emit('update:is-sign-up-zz', false)
    },
    initImg: function () {
      this.imgSrc = this.$request.request_url + 'training-skill/image-code?unique_code=' + this.$elId + '&random=' + Math.random()
    },
    subSigUp: function () {
      if (this.projectId > 0) {
        if (!this.electronicSignatureFile) {
          alert('未签名'); return false
        }
        var getParam = {}
        getParam['discipline_id'] = this.projectId
        getParam['class_id'] = this.classId
        getParam['phone'] = this.signPhone
        getParam['name'] = this.signName
        getParam['cid'] = this.cid
        getParam['company'] = this.company
        getParam['code'] = this.signCode
        getParam['unique_code'] = this.$elId
        getParam['political_outlook'] = this.political_outlook
        getParam['edu_level'] = this.edu_level

        let param = new FormData()
        if (this.electronicSignatureFile) {
          param.append('electronic_signature', this.electronicSignatureFile, 'signature.jpg')
        }
        for (let key in getParam) {
          param.append(key, getParam[key])
        }
        let config = {
          headers: {'Content-Type': 'multipart/form-data'}
        }
        this.$request.postFile('training-skill/secondary-vocational-training', param, config, response => {
        // this.$request.post('training-skill/secondary-vocational-training',getParam,response => {
          if (response.status == 200) {
            if (response.data.code == 200) {
              alert('报名成功')
              this.$emit('update:is-sign-up-zz', false)
            } else {
              alert(response.data.message)
            }
          }
        }, error => {
          console.log(error)
        })
      } else {
        alert('无项目信息')
      }
    },
    getdata: function () {
      this.$request.get('training-skill/social-training-enroll-data', {}, response => {
        if (response.status == 200) {
          if (response.data.code == 200) {
            this.e_list = response.data.data
          } else {
            alert(response.data.message)
          }
        }
      }, error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
   .stt {
    padding: 20px 30px;
  }
  .bmdiv{z-index: 1000;left: 0;right: 0;top: 0;bottom: 0;background: rgba(0, 0, 0, .7);}
  .bmdiv::after{content: '';display: inline-block;height: 100%;vertical-align: middle;}
  .bmdiv form{width: 450px;}
  .bmdiv input{height: 40px;border: 1px solid #d8d8d8;}
  .bmdiv input{padding: 0 20px 0 20px;outline: none;}
  .bmdiv input:focus{border-color: #147ad8;box-shadow: 0 0 5px #147ad8;}
  .bmdiv input.wd100{width: 100%;}
  .bmdiv .code{max-width: 150px;}
  .bmdiv .pass{background-position: -10px -208px;}
  .bmdiv .tcode{margin-right: 20px;width: 230px;}
  .bmdiv .zbtn{height: 45px;line-height: 45px;letter-spacing:5px;outline: none;}
  .bmdiv .zbtn:hover{box-shadow: 0 0 5px #147ad8;}
  .bmdiv .close{right: -18px;top: -18px;width: 36px;height: 36px;line-height: 36px;background: #147ad8;}
  .item-class{margin-bottom: 25px;font-size: 22px;font-weight: bold;}
  .item-content{margin-bottom: 30px;}
  .item-content td{border: 1px solid #000000;padding: 10px 0 10px 0;}
  .item-content table{border-collapse: collapse;width:100%;text-align: center;}
  .signature{position: relative;}
  .signature::before{content: '';display: block;z-index: 100;width: 100%;height: 100%;position: absolute;}
  .signature span{font-size: 16px;vertical-align: middle}
  .signature input{vertical-align: middle;margin-left: 10px;}

  .bmdiv select{height: 40px;border: 1px solid #d8d8d8;}
  .bmdiv select{padding: 0 20px 0 20px;outline: none;}
  .bmdiv select:focus{border-color: #147ad8;box-shadow: 0 0 5px #147ad8;}
  .bmdiv select.wd100{width: 100%;}
   form{
    height: 70%;
  }
  .mdiv{
    margin: 0px auto; 
    padding: 5px 10px;
    width: 400px;
    max-height: calc( 100% - 180px);
    overflow-y: auto;
  }
 .mdiv::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }

 .mdiv::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      border-radius: 20px;
      background-color: #eee;
  }

  .mdiv::-webkit-scrollbar-thumb {
      border-radius: 20px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .2);
      background-color: #ccc;
  }

   form .zbtn-gblue2{
     margin: auto;
     position: absolute;
     left: 0;
     right: 0;
     bottom: 30px;
     width: 80%;
     transition: all .2s;
     border-radius: 2px;
   }
   form .zbtn-gblue2:hover{
     bottom: 32px;
   }
</style>


// WEBPACK FOOTER //
// src/components/train/project/signUpZz.vue